import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import aiServicesReducer from './aiServicesSlice';
import authReducer from './authSlice';
import cptExamsReducer from './cptExamSlice';
import reportReducer from './reportSlice';
import systemHealthReducer from './systemHealthSlice';
import templateReducer from './templateSlice';
import transcriptionReducer from './transcriptionSlice';
import validationReducer from './validationSlice';
import uiPreferencesReducer from './uiPreferencesSlice';
import userPreferencesReducer from './userPreferencesSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'uiPreferences', 'userPreferences'], // persisted slices
};

const rootReducer = combineReducers({
  auth: authReducer,
  transcription: transcriptionReducer,
  report: reportReducer,
  templates: templateReducer,
  systemHealth: systemHealthReducer,
  aiServices: aiServicesReducer,
  cptExams: cptExamsReducer,
  validation: validationReducer,
  uiPreferences: uiPreferencesReducer,
  userPreferences: userPreferencesReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;